// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  &.rockstar {
    .star-fill {
      fill: ${(props) => props.theme.colorPalette.blue[300]};
    }
  }

  &.superstar {
    .star-fill {
      fill: ${(props) => props.theme.colorPalette.blue[1900]};
    }
  }

  &.megastar {
    .star-fill {
      fill: ${(props) => props.theme.colorPalette.blue[800]};
    }
  }

  &.rockstar,
  &.superstar,
  &.megastar {
    .star-border {
      fill: ${(props) => props.theme.colorPalette.gray[3900]};
    }
    .star {
      filter: drop-shadow(4px 3px ${(props) => props.theme.colorPalette.blue[1600]});
    }
  }
`;

export default styles;
